// ConferenceSchedule.styles.js
import styled from '@emotion/styled';

export const Container = styled.main`
	display: flex;
	flex-direction: column;
	gap: 4rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding-top: 8rem;
	overflow-x: auto;
	::-webkit-scrollbar {
		display: none;
	}
	@media (max-width: 900px) {
		padding-left: 2rem;
	}
`;

export const ContentTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl || '2rem'};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi || '600'};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
`;

export const InfoBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
	padding: 2rem;
	background-color: #f1f3f5;
`;

export const InfoTitle = styled.p`
	color: #01337d;
	font-size: 2rem;
	font-weight: 700;
	line-height: 130%;
	letter-spacing: -0.6px;
`;

export const InfoRow = styled.p`
	display: flex;
	gap: 1.2rem;
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	span {
		flex: 0 0 auto;
		font-weight: 700;
	}
	strong {
		font-weight: 600;
	}

	@media (max-width: 900px) {
		flex-direction: column;
		gap: 0.4rem;
	}
`;

export const DaySection = styled.section`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
`;

export const TableHead = styled.p`
	font-size: 2rem;
	font-weight: 600;
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #01337d;
`;

export const Table = styled.div`
	display: grid;
	grid-template-columns: 16rem 68.2rem;
	grid-auto-rows: minmax(52px, auto);
	.grid-column-1 {
		grid-column: 1 / span 2;
	}
	@media (max-width: 900px) {
		min-width: 84.2rem;
	}
`;

export const TableHeadCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #00377b;
	color: white;
	padding: 0.8rem 1.2rem;
	text-align: left;
	border-right: 2px solid white;
	height: 5.4rem;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	line-height: 150%;
`;

export const TableCell = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	background-color: #f1f3f5;
	padding: 0.8rem 1.2rem;
	border-right: 2px solid white;
	border-bottom: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #212529;
	gap: 0.4rem;
	a {
		text-decoration: underline;
	}
	strong {
		&.bold {
			font-weight: 700;
		}
	}
	&.row {
		flex-direction: row;
		justify-content: start;
	}
	&.bold {
		font-weight: 700;
	}
	&.point {
		color: #01337d;
	}
	&.center {
		align-items: center;
		text-align: center;
		background-color: #ced4da;
		line-height: 150%;
	}
	&.chair {
		background-color: #e9ecef;
		font-weight: 700;
		color: #01337d;
	}
	&.min-height {
		min-height: 5.2rem;
	}
	&.program-title {
		font-weight: 700;
	}
	&.speaker {
		background-color: #f8f9fa;
	}
	.point {
		color: #00377b;
		font-weight: 700;
	}
`;

export const PositionCell = styled(TableCell)`
	color: #00377b;
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
`;
